import { Action } from "../interface";
import { CountriesActivites } from "../interface/Back";
import { InitialState } from "../types";
import { ActionTypes, F_O } from "./Action_Types";

const initialState: InitialState = {
  countries: [],
  copyCountries: [],
  activities: [],
}

export const reducer = (state: InitialState = initialState, action: Action): InitialState => {
  switch (action.type) {
    case ActionTypes.GET_ALL_COUNTRIES:
      return {
        ...state,
        countries: action.payload,
        copyCountries: action.payload,
      };
    case ActionTypes.GET_COUNTRIES_BY_NAME:
      return {
        ...state,
        countries: action.payload,
      };
    case ActionTypes.FILTER_BY_CONTINENTS: //* FUNCIONA
      let Continentes = state.copyCountries;
      let filterContinents = 
        action.payload === F_O.ALL
          ? Continentes
          : Continentes.filter(el => el.continents === action.payload);
      return {
        ...state,
        countries: filterContinents,
      };
    case ActionTypes.FILTER_BY_ACTIVITIES: //* FUNCIONA
      let Actividades = state.copyCountries;
      let filterActivities: CountriesActivites[] = [];
      for (let el of Actividades) {
        for (let actividad of el.activities) {
          if (actividad.name === action.payload) {
            filterActivities.push(el);
          }
        }
      }
      filterActivities = action.payload === F_O.ALL ? Actividades : filterActivities;
      return {
        ...state,
        countries: filterActivities,
      };
    case ActionTypes.ORDER_BY_NAME: //* FUNCIONA
      let all_name = state.copyCountries;
      let order_name =
        action.payload === F_O.ASC
          ? all_name.sort((a, b) => {
              if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
              if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
              return 0;
            })
          : all_name.sort((a, b) => {
              if (a.name.toLowerCase() > b.name.toLowerCase()) return -1;
              if (a.name.toLowerCase() < b.name.toLowerCase()) return 1;
              return 0;
            });
      // console.log('ORDER NAME REDUCER:', order_name)
      return {
        ...state,
        countries: order_name,
      };
    case ActionTypes.ORDER_BY_POPULATION: //* FUNCIONA
      let orderPopulation = state.copyCountries;
      orderPopulation = orderPopulation.sort((a, b) => {
        if (action.payload === F_O.Mayor_Poblacion) {
          return b.population - a.population;
        }
        return a.population - b.population;
      });
      return {
        ...state,
        countries: orderPopulation,
      };
    case ActionTypes.GET_COUNTRIES_BY_ID:
      return {
        ...state,
        detail: action.payload,
      };
    case ActionTypes.CREATE_ACTIVITY:
      return {
        ...state,
      };
    case ActionTypes.GET_ALL_ACTIVITIES:
      return {
        ...state,
        activities: action.payload,
      };
    default: return state;
  }
}